import './newSections.css';

// ─── Pairing data (sourced from client UI.xlsx) ───────────────────────────────
// Key = single-piece id, Value = array of pairing options

export const PAIRING_DATA = {
  sadri: {
    heading: 'How would you like to wear your Sadri?',
    subheading: 'Select the base outfit and start customizing',
    pairings: [
      {
        id: 'sadri-short-kurta-pajama',
        label: 'With Short Kurta Pajama',
        desc: 'Casual layered ethnic look',
        // types to set on the kurta page when this pairing is picked:
        types: [1, 0, 1, 1], // Kurta + Pajama + Sadri
        navigateTo: 'kurta',
      },
      {
        id: 'sadri-pant-shirt',
        label: 'With Pant Shirt',
        desc: 'Indo-western fusion look',
        types: [1, 0, 1, 1],
        navigateTo: 'kurta',
      },
      {
        id: 'sadri-kurta-pajama',
        label: 'With Kurta Pajama',
        desc: 'Formal traditional look',
        types: [1, 0, 1, 1],
        navigateTo: 'kurta',
      },
    ],
  },
  kurta: {
    heading: 'How would you like to wear your Kurta?',
    subheading: 'Select the bottom wear and start customizing',
    pairings: [
      {
        id: 'kurta-salwar',
        label: 'With Salwar',
        desc: 'Classic salwar-kurta pairing',
        types: [1, 0, 1, 0],
        navigateTo: 'kurta',
      },
      {
        id: 'kurta-pajama',
        label: 'With Pajama',
        desc: 'Traditional kurta-pajama look',
        types: [1, 0, 1, 0],
        navigateTo: 'kurta',
      },
      {
        id: 'kurta-pant-pajama',
        label: 'With Pant Pajama',
        desc: 'Smart modern ethnic look',
        types: [1, 0, 1, 0],
        navigateTo: 'kurta',
      },
    ],
  },
  pajama: {
    heading: 'How would you like to wear your Pajama?',
    subheading: 'Select the top wear and start customizing',
    pairings: [
      {
        id: 'pajama-short-kurta',
        label: 'With Short Kurta',
        desc: 'Relaxed casual ethnic look',
        types: [1, 0, 1, 0],
        navigateTo: 'kurta',
      },
      {
        id: 'pajama-kurta',
        label: 'With Kurta',
        desc: 'Classic traditional pairing',
        types: [1, 0, 1, 0],
        navigateTo: 'kurta',
      },
      {
        id: 'pajama-pathani',
        label: 'With Pathani',
        desc: 'Bold ethnic statement look',
        types: [1, 0, 1, 0],
        navigateTo: 'kurta',
      },
    ],
  },
  blazer: {
    heading: 'How would you like to wear your Blazer?',
    subheading: 'Select the outfit below and start customizing',
    pairings: [
      {
        id: 'blazer-kurta',
        label: 'With Kurta',
        desc: 'Indo-western fusion style',
        types: [1, 1, 1, 0],
        navigateTo: 'kurta',
      },
      {
        id: 'blazer-tshirt',
        label: 'With T-Shirt',
        desc: 'Smart casual everyday look',
        types: [1, 1, 1, 0],
        navigateTo: 'kurta',
      },
      {
        id: 'blazer-shirt',
        label: 'With Shirt',
        desc: 'Business casual formal look',
        types: [1, 1, 0, 0],
        navigateTo: 'formal',
      },
    ],
  },
};

// ─── Pairing Card Icons (simple SVG placeholders, replace with real product photos) ─
function PairingIcon({ type }) {
  // Simple silhouette icons; swap out for real category photos in production
  const icons = {
    'short-kurta': (
      <svg viewBox="0 0 60 90" fill="none" xmlns="http://www.w3.org/2000/svg" width="48" height="72">
        <rect x="15" y="8" width="30" height="32" rx="3" fill="#C8C5BB"/>
        <rect x="12" y="41" width="16" height="38" rx="3" fill="#C8C5BB"/>
        <rect x="32" y="41" width="16" height="38" rx="3" fill="#C8C5BB"/>
        <circle cx="30" cy="5" r="5" fill="#DDD9D0"/>
      </svg>
    ),
    'full-kurta': (
      <svg viewBox="0 0 60 90" fill="none" xmlns="http://www.w3.org/2000/svg" width="48" height="72">
        <rect x="15" y="8" width="30" height="45" rx="3" fill="#C8C5BB"/>
        <rect x="12" y="54" width="16" height="28" rx="3" fill="#C8C5BB"/>
        <rect x="32" y="54" width="16" height="28" rx="3" fill="#C8C5BB"/>
        <circle cx="30" cy="5" r="5" fill="#DDD9D0"/>
      </svg>
    ),
    'pant': (
      <svg viewBox="0 0 60 90" fill="none" xmlns="http://www.w3.org/2000/svg" width="48" height="72">
        <rect x="18" y="5" width="24" height="28" rx="2" fill="#DDD9D0"/>
        <rect x="12" y="34" width="18" height="48" rx="3" fill="#C8C5BB"/>
        <rect x="30" y="34" width="18" height="48" rx="3" fill="#C8C5BB"/>
      </svg>
    ),
    'default': (
      <svg viewBox="0 0 60 90" fill="none" xmlns="http://www.w3.org/2000/svg" width="48" height="72">
        <rect x="15" y="8" width="30" height="38" rx="3" fill="#C8C5BB"/>
        <rect x="12" y="47" width="16" height="34" rx="3" fill="#DDD9D0"/>
        <rect x="32" y="47" width="16" height="34" rx="3" fill="#DDD9D0"/>
        <circle cx="30" cy="5" r="5" fill="#DDD9D0"/>
      </svg>
    ),
  };
  return icons[type] || icons['default'];
}

// ─── Component ────────────────────────────────────────────────────────────────

function KismePehnnaHai({ selectedSingleId, onSelectPairing, selectedPairingId }) {
  const data = PAIRING_DATA[selectedSingleId];

  // If no data for this single item, don't render
  if (!data) return null;

  return (
    <section className="cs-pairing-section" id="cs-pairing-section">
      <div className="cs-container">

        {/* ── Heading ── */}
        <div className="cs-section-header">
          <h2 className="cs-heading">{data.heading}</h2>
          <p className="cs-subheading">{data.subheading}</p>
        </div>

        {/* ── Pairing Cards ── */}
        <div className="cs-pairing-grid">
          {data.pairings.map((pair) => (
            <div
              key={pair.id}
              className={`cs-pair-card ${selectedPairingId === pair.id ? 'cs-pair-card--selected' : ''}`}
              onClick={() => {
                onSelectPairing(pair);
                // Scroll to sub-category section after selection
                setTimeout(() => {
                  document.getElementById('cs-subcategory-section')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }, 100);
              }}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => e.key === 'Enter' && onSelectPairing(pair)}
            >
              {/* Selected check indicator */}
              {selectedPairingId === pair.id && (
                <div className="cs-pair-check-mark">✓</div>
              )}

              {/* Visual area — replace with actual product photo in production */}
              <div className="cs-pair-visual">
                <PairingIcon type="default" />
                {/* 
                  DEVELOPER NOTE:
                  Replace the <PairingIcon> above with an <img> tag using a real product photo.
                  Recommended: use a lifestyle/lookbook photo showing the pairing.
                  Example: <img src={pairingImages[pair.id]} alt={pair.label} className="cs-pair-img" />
                */}
              </div>

              {/* Info */}
              <div className="cs-pair-info">
                <h3 className="cs-pair-label">{pair.label}</h3>
                <p className="cs-pair-desc">{pair.desc}</p>
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
}

export default KismePehnnaHai;
